import "./TakePaymentRadioTabs.scss";
import { Radio } from "antd";
import { useFeatureFlag } from "utils/useFeatureFlag";
import type { TakePaymentTabType } from "../CreateTakePaymentModals";

interface TakePaymentRadioTabsProps {
    readonly takePaymentTab: TakePaymentTabType;
    readonly setTakePaymentTab: (tab: TakePaymentTabType) => void;
}

export const TakePaymentRadioTabs = ({ takePaymentTab, setTakePaymentTab }: TakePaymentRadioTabsProps) => {
    const insuranceProcessingEnabled = !!useFeatureFlag("insurance_processing", false);

    if (!insuranceProcessingEnabled) {
        return null;
    }

    return (
        <Radio.Group
            className="take-payment-radio-tabs"
            block
            optionType="button"
            buttonStyle="solid"
            value={takePaymentTab}
            onChange={(e) => setTakePaymentTab(e.target.value as TakePaymentTabType)}
        >
            <Radio.Button value="patient-payment">Patient Payment</Radio.Button>
            <Radio.Button value="insurance-payment">Insurance Payment</Radio.Button>
        </Radio.Group>
    );
};
